import httpClient from '../http'

export default {
  get(companyCode) {
    return httpClient.get(`/api/logo/${companyCode}`)
  }
}
